import { ComponentMap } from '@cinch-nx/data-storyblok'
import { NextImage, RichText, IconWithText } from '../atom-blocks'
import { FinanceRepresentativeExample } from '@cinch-nx/shared-ui'

export const atomStoryblokComponents: ComponentMap = {
  FinanceRepresentativeExample,
  Image_v2: NextImage,
  Image: NextImage,
  RichText,
  IconWithText,
}
